import { MemberStatus } from "../../../../hooks/manageMembers/models/MemberStatus";
import { CommunityAdminBanModal } from "../../../communityAdmin/components/CommunityAdminBanModal";
import { ProfileMemberBanList } from "./ProfileMemberBanList";

type Props = {
    username: string;
    userId: number;
    status:  MemberStatus | null;
    showModal: boolean;
    onCloseModal: () => void;
    banUser: (type: "temporary" | "permanent", duration: number, reason: string) => Promise<void>;
    reloadStatus: () => void;
}

export const ProfileMemberStatusAction = ({ username, status, showModal, onCloseModal, userId, banUser, reloadStatus }: Props) => {
    return (
        <>
        {status && userId && showModal && (
            <>
            { status.status === 'Inactive' ? <></> : 
            status.status === 'Active' ? (
                <CommunityAdminBanModal
                    id={userId} 
                    target="user"
                    username={username}
                    onClose={onCloseModal} 
                    onBan={(target, _, type, reason, duration) => {
                        if(target === 'user')
                            banUser(type, duration, reason)
                        onCloseModal();
                    }} 
                />
            ):(
                <ProfileMemberBanList 
                    status={status}
                    userId={userId}
                    username={username}
                    onClose={onCloseModal}
                    onReload={reloadStatus}
                />
            )}
            </>
        )}
        </>
    )
}